module.exports = __webpack_public_path__ + "static/media/left.87e27296.svg";